export const APP_NAME = process.env.REACT_APP_APP_NAME;

export const PRODUCTION_URL =
  process.env.REACT_APP_PRODUCTION_URL ||
  "https://https://ignite-apis-dev.azurewebsites.net/api";
